import ChatCreateGroupLayout from '@/components/Chat/ChatCreateGroupLayout';

export const unstable_settings = {
  anchor: 'index',
};

export default function PrivateChatCreateGroupLayoutRoute() {
  return <ChatCreateGroupLayout />;
}
